var path = './approvals/listRequests/content_partial.html';
var html = "<div class=\"approvals-list-container\">\n    <approval-requests-list show=\"{{viewType}}\"></approval-requests-list>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;